import React, {useEffect, useRef, useState} from 'react';
import {Card, Modal, Button, Icon, Grid, Dropdown, Input, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';
import {getModelTasksColumns} from './modelTasksModalColumns';
import ModelTasksTable from './modelTasksModalTable';
import {getDropdownOptions} from '../../../common/util/dropdown';

import '../index.scss';

const {
  fetchModelTasksList,
  fetchTargetModelTasksList,
  fetchLogisticTasksList,
  cleanTargetModelsTasks,
  updateModelTasks,
} = Actions;

const NEW_TASK_OBJ = {
  'uniqueId': '',
  'serviceCode1': '',
  'serviceCode2': '',
  'serviceCode3': '',
  'area': '',
  'stdFlat': '',
  'localFlat': '',
  'price': '',
};

const ModelTasksModal = ({modelId, modelsList}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [addTaskSection, setAddTaskSection] = useState(false);
  const [addTask, setAddTask] = useState(NEW_TASK_OBJ);
  const [copyTaskSection, setCopyTaskSection] = useState(false);
  const [targetModel, setTargetModel] = useState('');
  const logisticModelTasks = useSelector((state) => state.logisticModelTasks.list);
  const targetModelTasks = useSelector((state) => state.targetModelTasks.list) || [];
  const logisticTasks = useSelector((state) => state.logisticTasks.list);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [taskToEdit, setTaskToEdit] = useState(null);
  const [lastInputChanged, setLastInputChanged] = useState({'inputId': null, 'caretPos': 0});
  const [currentPage, setCurrentPage] = useState(0);
  let inputRef = useRef();
  const InputsRefs = [];
  const dispatch = useDispatch();
  
  const openModelTasksModal = (e) => {
    e.preventDefault();
    dispatch(fetchModelTasksList(modelId));
    dispatch(fetchLogisticTasksList({'status': 'A'}));
    setModalOpened(true);
  };

  const closeModelTasksModal = (e) => {
    e.preventDefault();
    setAddTask(NEW_TASK_OBJ);
    setTargetModel('');
    setSelectedTasks([]);
    setAddTaskSection(false);
    setCopyTaskSection(false);
    dispatch(cleanTargetModelsTasks());
    setCurrentPage(0);
    setModalOpened(false);
  };

  const showAddTaskSection = (e, value) => {
    e.preventDefault();
    setAddTaskSection(value);
  };

  const showCopySection = (e, value) => {
    e.preventDefault();
    !value && setSelectedTasks([]);
    !value && dispatch(cleanTargetModelsTasks());
    !value && setTargetModel('');
    setCopyTaskSection(value);
  };

  const onChengeNewTaskValue = (e, input) => {
    e.preventDefault();
    if (input.id === 'uniqueId') {
      const taskSelected = logisticTasks.find((x) => x.uniqueId === input.value);
      if (taskSelected) {
        setAddTask({...addTask,
          'uniqueId': taskSelected.uniqueId,
          'serviceCode1': taskSelected.serviceCode1,
          'serviceCode2': taskSelected.serviceCode2,
          'serviceCode3': taskSelected.serviceCode3,
          'area': taskSelected.area,
          'stdFlat': taskSelected.stdFlat,
        });
      }
    } else {
      setAddTask({...addTask, [input.id]: input.value});
    }
  };

  const setCopyTasksTargetModel = (e, value) => {
    e.preventDefault();
    setTargetModel(value);
    const selectedModel = modelsList.find((x) => x.modelId === value);
    dispatch(fetchTargetModelTasksList(selectedModel.modelId));
  };

  const addTaskToModel = (e) => {
    e.preventDefault();
    dispatch(updateModelTasks(modelId, {'tasks': [{...addTask}], 'action': 'add'}));
  };

  const editModelTask = (e, currentPage) => {
    e.preventDefault();
    dispatch(updateModelTasks(modelId, {'tasks': [{...taskToEdit}], 'action': 'edit'}));
  };

  const disableModelTask = (e, input, task) => {
    e.preventDefault();
    dispatch(updateModelTasks(modelId, {'tasks': [{...task, 'status': input.checked ? 'A' : 'P'}], 'action': 'edit'}));
  };

  const copyTasksToModel = (e) => {
    e.preventDefault();
    dispatch(updateModelTasks(targetModel, {'tasks': [...selectedTasks], 'action': 'copy'}));
  };

  const setRef = (input) => {
    inputRef = input;
    InputsRefs.push(inputRef);
  };

  useEffect(() => {
    const input = InputsRefs.find((x) => x.props.id === lastInputChanged.inputId);
    if (input && taskToEdit) {
      input.focus();
      input.inputRef.current
        .setSelectionRange(lastInputChanged.caretPos, lastInputChanged.caretPos);
    }
  }, [taskToEdit]);

  useEffect(() => {
    setTaskToEdit(null);
    setAddTask(NEW_TASK_OBJ);
    setAddTaskSection(false);
  }, [logisticModelTasks]);

  const columns2 = getModelTasksColumns();

  const renderCopySection = () => {
    return (!copyTaskSection ? '' :
      <Card raised fluid>
        <Card.Content >
          <Grid>
            <Grid.Row verticalAlign='middle'>
              <Grid.Column width={6}>
                <div className="ui fluid labeled input">
                  <div className="ui label label">Modelo destino</div>
                  <Dropdown fluid search selection id='modelId'
                    value={targetModel} labeled className='labeled-dropdown'
                    options={getDropdownOptions(modelsList.filter((x) => x.modelId !== modelId),
                      'modelId', 'description')}
                    onChange={(e, input) => setCopyTasksTargetModel(e, input.value)} />
                </div>
              </Grid.Column>
              <Grid.Column width={3}>
                <Input label='Tareas asignadas' value={targetModelTasks.length} disabled fluid />
              </Grid.Column >
              <Grid.Column width={3}>
                <Input label='Tareas a copiar' value={selectedTasks.length} disabled fluid />
              </Grid.Column >
              {
                <Grid.Column width={4} textAlign='right'>
                  <Button content='Copiar tareas seleccionadas' secondary size='tiny'
                    disabled={!(targetModel && selectedTasks.length > 0)}
                    onClick={(e) => copyTasksToModel(e)}
                    icon={<Icon className='copy' color='green' size='big' />} />
                </Grid.Column>
              }
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  };

  const renderAddTaskSection = () => {
    return (!addTaskSection ? '' :
      <Card raised fluid>
        <Card.Content >
          <Grid>
            <Grid.Row verticalAlign='middle'>
              <Grid.Column width={8}>
                <div className="ui fluid labeled input">
                  <div className="ui label label">Añadir Tarea</div>
                  <Dropdown fluid search selection id='uniqueId'
                    value={addTask.uniqueId} labeled className='labeled-dropdown'
                    onChange={(e, input) => onChengeNewTaskValue(e, input)}
                    options={getDropdownOptions(logisticTasks, 'uniqueId', 'description')} />
                </div>
              </Grid.Column>
              <Grid.Column width={2}>
                <Input label='ID' fluid disabled value={addTask.serviceCode3} />
              </Grid.Column>
              <Grid.Column width={3}>
                <Input label='Flat Rate Std' fluid disabled value={addTask.stdFlat} />
              </Grid.Column>
              <Grid.Column width={3}>
                <Input label='Área' fluid disabled value={addTask.area} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{'padding': '0 0 0.5em 0'}}>
              <Grid.Column width={3}>
                <Input type='number' label='Flat Rate Local' fluid id='localFlat' step=".01"
                  onChange={(e, input) => onChengeNewTaskValue(e, input)} />
              </Grid.Column>
              <Grid.Column width={3}>
                <Input type='number' label='Precio' fluid id='price' step=".01"
                  onChange={(e, input) => onChengeNewTaskValue(e, input)} />
              </Grid.Column>
              <Grid.Column width={10} textAlign='right'>
                <Button content='ASIGNAR' secondary size='tiny'
                  disabled={!(addTask.serviceCode3 && addTask.localFlat && addTask.price)}
                  icon={<Icon className='save' color='green' size='big' />}
                  onClick={(e) => addTaskToModel(e)} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  };

  const renderAsignButton = () => {
    return (
      addTaskSection ?
        <Icon className='minus-circle' link size='big' color='red'
          onClick={(e) => showAddTaskSection(e, false)} /> :
        <Popup
          disabled={copyTaskSection}
          trigger={
            <Icon className='add-circle' size='big' color='green' disabled={copyTaskSection}
              link={!copyTaskSection}
              onClick={(e) => showAddTaskSection(e, true)} />
          }
          content='Asignar nueva tarea'
          position='top center'
          inverted
        />
    );
  };
  
  const renderCopyButton = () => {
    return (
      copyTaskSection ?
        <Icon className='minus-circle' link size='big' color='red'
          onClick={(e) => showCopySection(e, false)} /> :
        <Popup
          disabled={addTaskSection}
          trigger={
            <Icon className='copy' size='big' color='green' disabled={addTaskSection}
              link={!addTaskSection}
              onClick={(e) => showCopySection(e, true)} />
          }
          content='Copiar tareas'
          position='top center'
          inverted
        />
    );
  };

  const renderModalTitle = () => {
    return (<>
      <div>Tareas del modelo {modelId} ({modelsList.find((x) => x.modelId === modelId).description})</div>
      <span style={{'fontSize': '80%', 'fontWeight': '400'}}>Total asignadas: {logisticModelTasks.length}</span>
    </>);
  };

  return (
    <Modal
      trigger={<Icon className='assignment-turned-in' size='big' color={'red'} link
        onClick={(e) => openModelTasksModal(e)} />
      }
      open={modalOpened}
      onClose={(e) => closeModelTasksModal(e)}
      size='fullscreen'
    >
      <Modal.Header>
        <Grid columns={2}>
          <Grid.Row verticalAlign='middle'>
            <Grid.Column>{renderModalTitle()}</Grid.Column>
            <Grid.Column textAlign='right'>
              {renderAsignButton()}
              {renderCopyButton()}
            </Grid.Column>
            <Grid.Column textAlign='right'>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Header>
      <Modal.Content>
        {renderAddTaskSection()}
        {renderCopySection()}
        <ModelTasksTable tableColumns={columns2} tableData={logisticModelTasks}
          tasks={{selectedTasks, setSelectedTasks, copyTaskSection}}
          edit={{taskToEdit, setTaskToEdit, setRef, setLastInputChanged,
            editModelTask, disableModelTask, setCurrentPage, currentPage}} />
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={(e) => closeModelTasksModal(e)}>
              Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModelTasksModal;
